import Breadcrumb from "@/components/feature/Breadcrumb";

const overview = [
  { value: "9.1", label: "综合评分", icon: "ri-star-line" },
  { value: "2.3k+", label: "读者热议", icon: "ri-chat-3-line" },
  { value: "86%", label: "愿意推荐", icon: "ri-thumb-up-line" },
  { value: "128+", label: "追更话数", icon: "ri-book-open-line" },
];

function ReviewsHeader() {
  return (
    <section className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "读者评价" }]} />
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-chat-3-line"></i> 读者评价
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            读者口碑与讨论，听听大家怎么说
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            结局考据党、人物党、治愈系与新读者……来自不同追更阵营的真实评价与讨论，一起看看嘿咻嘿咻漫画在读者心中留下的印象。
          </p>
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {overview.map((o) => (
            <div key={o.label} className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${o.icon} text-lg`}></i>
              </span>
              <dd className="mt-3 font-heading text-2xl font-bold text-foreground-950">{o.value}</dd>
              <dt className="mt-1 text-xs text-foreground-500">{o.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default ReviewsHeader;